const ASSETS_CACHE = 'assetsUploads';

export const getLocalStorage = () => JSON.parse(localStorage.getItem(ASSETS_CACHE) || '{}');

export const setLocalStorage = (cache) => localStorage.setItem(
  ASSETS_CACHE,
  JSON.stringify(cache)
);